module.exports = require("timers");


//////////////////
// WEBPACK FOOTER
// external "timers"
// module id = 309
// module chunks = 0